'use client'

import { useEffect } from 'react'

import { LuRefreshCw } from 'react-icons/lu'

import ErrorToast from '@/core/components/error-toast'
import { Button } from '@/core/components/form/button/button'
import { isDev } from '@/core/config/env'
import { debugLog } from '@/core/utils/debug'

type ErrorProps = {
  error: Error & { digest?: string }
  retry: () => void
}

export default function RootError({ error, retry }: ErrorProps) {
  useEffect(() => {
    debugLog('render', 'RootError', {
      message: error.message,
      digest: error.digest,
      stack: error.stack,
    })
  }, [error])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <ErrorToast
        message={
          isDev && error.message
            ? error.message
            : '화면을 불러오지 못했어요. 잠시 후 다시 시도해 주세요.'
        }
      />
      <Button variant="secondary" onClick={retry}>
        <LuRefreshCw aria-hidden="true" className="size-4" />
        다시 시도
      </Button>
    </div>
  )
}
